"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.LoaderGhostCard = void 0;
require("./LoaderGhostCard.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _LoaderGhostBase = _interopRequireDefault(require("../LoaderGhostBase/LoaderGhostBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// Adjust path as needed

const LoaderGhostCard = props => {
  const {
    variant = defaultProps.variant,
    className,
    ...rest
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-LoaderGhostCard', `pal-c-LoaderGhostCard--${variant}`, className);
  const hasContent = variant === 'textRectangle' || variant === 'textCircle';
  const renderContent = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pal-c-LoaderGhostCard__content"
    }, variant === 'textRectangle' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_LoaderGhostBase.default, {
      variant: "pill",
      className: "pal-c-LoaderGhostCard__line pal-c-LoaderGhostCard__line--short"
    }), /*#__PURE__*/_react.default.createElement(_LoaderGhostBase.default, {
      variant: "pill",
      className: "pal-c-LoaderGhostCard__line pal-c-LoaderGhostCard__line--long"
    })), variant === 'textCircle' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_LoaderGhostBase.default, {
      variant: "pill",
      className: "pal-c-LoaderGhostCard__line pal-c-LoaderGhostCard__line--xs"
    })));
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassName,
    "aria-hidden": "true"
  }, rest), /*#__PURE__*/_react.default.createElement(_LoaderGhostBase.default, {
    variant: variant === 'textCircle' ? 'circle' : 'default',
    className: "pal-c-LoaderGhostCard__media"
  }), hasContent && renderContent());
};

/**
 * Property type definitions
 * @typedef LoaderGhostCardProps
 * @type {object}
 * @property {string} variant - Determines the view of ghost card (default, textRectangle, textCircle).
 * @property {string} className - Optional classes.
 */
exports.LoaderGhostCard = LoaderGhostCard;
const propTypes = exports.propTypes = {
  /**
   * Determines the layout composition of the ghost card.
   */
  variant: _propTypes.default.oneOf(['default', 'textRectangle', 'textCircle']),
  /**
   * Optional classes.
   */
  className: _propTypes.default.string
};

/**
 * Property type definitions
 * @type {object}
 * @property {string} variant - variant: 'default' - sets the default variant of the LoaderGhostCard to default
 */
const defaultProps = exports.defaultProps = {
  variant: 'default'
};
LoaderGhostCard.propTypes = propTypes;
var _default = exports.default = LoaderGhostCard;